import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgVandar = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill='teal'
      d='M21.997 18.383H2v3.613h19.997zM19.438 2H2v14.577h19.996V4.559c0-1.48-1.078-2.559-2.558-2.559m-1.054 10.964H5.613V5.613h12.77z'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgVandar)
export default ForwardRef
